import Repository from '../Repository';
import {
    vue
} from "../../../app";

const url = '/admin/video';

export default {
    getGoals() {
        return Repository.get(`${url}/goals`, {
            localLoading: true
        });
    },

    getVideos(page = 1, series, videoTitle) {
        return Repository.get(`${url}`, {
            params: {
                page: page,
                series: series,
                video: videoTitle,
            }
        }, {
            localLoading: true
        });
    },


    getVideo(video) {
        return Repository.get(`${url}/${video}`, {
            localLoading: true
        });
    },

    getVideoStats(video, type = 'daily') {
        return Repository.get(`${url}/${video}/stats?type=${type}`);
    },
    getTotalVideoViews(video, type = 'daily') {
        return Repository.get(`${url}/${video}/views`);
    },

    getVideoFavorites(video, type = 'daily') {
        return Repository.get(`${url}/${video}/favorites?type=${type}`);
    },
    getVideoTotalFavorited(video) {
        return Repository.get(`${url}/${video}/favorites/total`);
    },




    uploadVideo(formData) {
        return Repository.post(`${url}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (e) => {
                let progressPercentage = Math.round((e.loaded * 100) / e.total);
                vue.$store.commit('setVideoUploadProgress', progressPercentage);
                vue.$Progress.set(progressPercentage);
            },
            localLoading: true
        });
    },

    updateVideo(video, formData) {
        return Repository.post(`${url}/${video}`, formData, {
            localLoading: true
        });
    },

    deleteVideo(video) {
        return Repository.delete(`${url}/${video}`, {
            localLoading: true
        });
    }
}
